window.PageSubNavigation = class {
  constructor(rootElement) {
    this.root = document.querySelector(rootElement);
    this.initNav();
  }

  initNav() {
    if (!this.root) {
      console.error("Page Sub Navigation root element not found.");
      return;
    }

    this.links = this.root.querySelectorAll('button[role="link"]');
    this.offset = this.root.clientHeight + 40;
    if(document.querySelector('.sitewide-banner')) {
      this.offset -= document.querySelector('.sitewide-banner').offsetHeight;
    }

    this.links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const anchorId = link.dataset.nriAnchorId
        this.scrollToAnchor(anchorId);
      });
    })

    window.addEventListener("scroll", () => {
      this.setNavbarPosition();
      this.updateActiveLink();
    });
  }

  setNavbarPosition() {
    const r = this.root.getBoundingClientRect();
    if (r.top <= 0) {
      if (!this.root.classList.contains("navbar-fixed")) {
        this.root.classList.add("navbar-fixed");
      }
    } else {
      if (this.root.classList.contains("navbar-fixed")) {
        this.root.classList.remove("navbar-fixed");
      }
    }
  }

  scrollToAnchor(anchorId) {
    const anchor = document.querySelector('#' + anchorId);
    if (!anchor) {
      console.error("Anchor element not found.");
      return;
    }
    const y = anchor.getBoundingClientRect().top + window.scrollY - this.offset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  updateActiveLink() {
    const mainSections = document.querySelectorAll('.entry-content > *:not(.page-sub-navigation)');
  
    let activeLink = null;
  
    for (let i = mainSections.length - 1; i >= 0; i--) {
      const section = mainSections[i];
      const rect = section.getBoundingClientRect();

      if (section.id && rect.top - this.offset <= 5) {
        activeLink = this.root.querySelector(`[data-nri-anchor-id="${section.id}"]`);
        break;
      }
    }
  
    this.links.forEach((link) => {
      link.classList.remove("active");
    });

    if (!activeLink || activeLink.classList.contains("active")) {
      return;
    }
  
    activeLink.classList.add("active");
  }
  
};
